import API from './api';

// Place a new order/invoice
export const placeOrder = async (orderData) => {
  try {
    const response = await API.post('/invoices', orderData);
    return response.data;
  } catch (error) {
    console.error('Error placing order:', error);
    throw error.response?.data || error.message;
  }
};

// Get all invoices with pagination
export const getInvoices = async (page = 1, limit = 10) => {
  try {
    const response = await API.get(
      `/invoices?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching invoices:', error);
    throw error.response?.data || error.message;
  }
};

// Get invoice by ID
export const getInvoiceById = async (id) => {
  try {
    const response = await API.get(`/invoices/id/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoice:', error);
    throw error.response?.data || error.message;
  }
};

// Get invoice by invoice number
export const getInvoiceByNumber = async (invoiceNumber) => {
  try {
    const response = await API.get(`/invoices/number/${invoiceNumber}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoice:', error);
    throw error.response?.data || error.message;
  }
};

// Update invoice payment status
export const updatePaymentStatus = async (id, status) => {
  try {
    const response = await API.put(`/invoices/${id}/payment-status`, { status });
    return response.data;
  } catch (error) {
    console.error('Error updating payment status:', error);
    throw error.response?.data || error.message;
  }
};